import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
export function SpeakersSection() {
  return <section id="referenten" className="py-16 md:py-24 bg-slate-50 border-y border-slate-200" data-id="element-627">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-628">
        <ScrollReveal variant="up" data-id="element-629">
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-20" data-id="element-630">
            <span className="text-[#59d0d4] font-extrabold tracking-widest uppercase text-sm mb-4 block" data-id="element-631">
              Lernen Sie von den Besten
            </span>
            <h2 className="text-2xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-632">
              Ihr Referenten-Team
            </h2>
            <p className="text-base sm:text-lg text-slate-500 font-medium leading-relaxed" data-id="element-633">
              Kompetenz und Erfahrung für Ihre zahnärztliche Fortbildung. Unsere
              Akademie setzt auf ein ausgewähltes Team erfahrener Referenten,
              die ihr Wissen verständlich, praxisnah und mit Leidenschaft
              vermitteln.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10" data-id="element-634">
          {/* Speaker 1 */}
          <ScrollReveal variant="scale" delay={100} data-id="element-635">
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-636">
              <div className="aspect-square overflow-hidden relative" data-id="element-637">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/schwenk.jpg" alt="Dr. Thomas Schwenk" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-638" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-639"></div>
              </div>
              <div className="p-5 sm:p-8 relative bg-white flex flex-col flex-grow" data-id="element-640">
                <h3 className="text-xl sm:text-2xl font-extrabold text-slate-700 mb-2" data-id="element-641">
                  Dr. Thomas Schwenk
                </h3>
                <p className="text-[#3b7780] font-bold text-sm mb-4 sm:mb-6 uppercase tracking-wider" data-id="element-642">
                  Spezialist für Ästhetik und Funktion (DGÄZ)
                </p>
                <ul className="space-y-3 mb-6 sm:mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-643">
                  <li className="flex items-start" data-id="element-644">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-645"></span>
                    Spezialist für Ästhetik & Funktion (DGÄZ)
                  </li>
                  <li className="flex items-start" data-id="element-646">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-647"></span>
                    Zahnarzttrainer seit 1998
                  </li>
                  <li className="flex items-start" data-id="element-648">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-649"></span>
                    Ausgezeichnet zum Dentrepreneur 2024
                  </li>
                </ul>
                <Link to="/referenten/dr-thomas-schwenk" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-650">
                  Mehr Infos{' '}
                  <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-651" />
                </Link>
              </div>
            </div>
          </ScrollReveal>

          {/* Speaker 2 */}
          <ScrollReveal variant="scale" delay={200} data-id="element-652">
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-653">
              <div className="aspect-square overflow-hidden relative" data-id="element-654">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/striegel.jpg" alt="Dr. Markus Striegel" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-655" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-656"></div>
              </div>
              <div className="p-5 sm:p-8 relative bg-white flex flex-col flex-grow" data-id="element-657">
                <h3 className="text-xl sm:text-2xl font-extrabold text-slate-700 mb-2" data-id="element-658">
                  Dr. Markus Striegel
                </h3>
                <p className="text-[#3b7780] font-bold text-sm mb-4 sm:mb-6 uppercase tracking-wider" data-id="element-659">
                  Spezialist für Ästhetik und Funktion (DGÄZ)
                </p>
                <ul className="space-y-3 mb-6 sm:mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-660">
                  <li className="flex items-start" data-id="element-661">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-662"></span>
                    Vizepräsident Deutsche Gesellschaft für Sportzahnmedizin
                    (oder kurzform DGSZM e.V.)
                  </li>
                  <li className="flex items-start" data-id="element-663">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-664"></span>
                    Zahnarzttrainer seit 1998
                  </li>
                  <li className="flex items-start" data-id="element-665">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-666"></span>
                    Ausgezeichnet zum Dentrepreneur 2024
                  </li>
                </ul>
                <Link to="/referenten/dr-markus-striegel" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-667">
                  Mehr Infos{' '}
                  <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-668" />
                </Link>
              </div>
            </div>
          </ScrollReveal>

          {/* Speaker 3 */}
          <ScrollReveal variant="scale" delay={300} data-id="element-669">
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-670">
              <div className="aspect-square overflow-hidden relative" data-id="element-671">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/herzog.jpg" alt="Dr. Johanna Herzog" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-672" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-673"></div>
              </div>
              <div className="p-5 sm:p-8 relative bg-white flex flex-col flex-grow" data-id="element-674">
                <h3 className="text-xl sm:text-2xl font-extrabold text-slate-700 mb-2" data-id="element-675">
                  Dr. Johanna Herzog M.Sc.
                </h3>
                <p className="text-[#3b7780] font-bold text-sm mb-4 sm:mb-6 uppercase tracking-wider" data-id="element-676">
                  Fokus auf Kieferorthopädie & Funktion (oder KFO und Funktion
                  kurzform)
                </p>
                <ul className="space-y-3 mb-6 sm:mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-677">
                  <li className="flex items-start" data-id="element-678">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-679"></span>
                    Vizepräsidentin Dentista e.V.
                  </li>
                  <li className="flex items-start" data-id="element-680">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-681"></span>
                    Generalsekretärin bei der DGSZM
                  </li>
                  <li className="flex items-start" data-id="element-682">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#59d0d4] mt-1.5 mr-3 flex-shrink-0" data-id="element-683"></span>
                    Referentin für Align, APW und DGSZM
                  </li>
                </ul>
                <Link to="/referenten/dr-johanna-herzog" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-684">
                  Mehr Infos{' '}
                  <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-685" />
                </Link>
              </div>
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal variant="up" delay={400} data-id="element-686">
          <div className="mt-16 text-center" data-id="element-687">
            <p className="text-slate-500 font-bold text-base sm:text-lg" data-id="element-688">
              Gemeinsam stehen sie für höchste Qualität und begleiten Sie auf
              Ihrem individuellen Fortbildungsweg.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}